//  Node imports
import { dispatcher, ingenuity, Meter, SpineBase } from "@quest/base-core";
import { FreeGameController } from "@quest/murka-games-behavior-panther/dist";
import { eventDispatchers } from "../Constants/EventDispatchers";
import { GameParserModel } from "../Platform/GameParserModel";

//  Class impotrs
export class FreeGameControllerGame extends FreeGameController {

    private grandJackpotMeter: Meter;
        private majorJackpotMeter: Meter;
        private minorJackpotMeter: Meter;
        private miniJackpotMeter: Meter;
        private reelGlow : SpineBase;
    
        /**
       * subscribeEvents method overrided for subscribe Jackpot Meters
       */
      protected subscribeEvents(): void {
        super.subscribeEvents();
        dispatcher.on(eventDispatchers.UPDATE_JACKPOT_METERS_VALUES_FG, this.updateJackpotMeterValues, this);
      }
    
      protected initializeComponents(): void {
        super.initializeComponents();
          this.reelGlow = this.view.getSpineById('freegame_reel_bg_glow');
          this.grandJackpotMeter = this.view.getMeterById("grandMeterText") as Meter;
          this.majorJackpotMeter = this.view.getMeterById("majorMeterText") as Meter;
          this.minorJackpotMeter = this.view.getMeterById("minorMeterText") as Meter;
          this.miniJackpotMeter = this.view.getMeterById("miniMeterText") as Meter;
      }
    
        /**
         * play reel glow animation
         */
        private playReelGlow():void{
          this.reelGlow.visible = true;
          this.reelGlow.playAnim('freegame_reel_glow',true);
        }

        /**
         * stop reel glow animation
         */
        private stopReelGlow():void{
          this.reelGlow.visible = false;
        }
      
    
      /**
      * updateJackpotMeterValues method set Jackpot Meters Values
      */
      private updateJackpotMeterValues(): void {
        let currentBet: number = ingenuity.parserModel.getCurrentTotalBet();
        const grandJackpot = currentBet *  ((ingenuity.parserModel as GameParserModel).getJackpotData()).grand; //update multiplier values from server - dependancy
        const majorJackpot = currentBet * ((ingenuity.parserModel as GameParserModel).getJackpotData()).major
        const minorJackpot = currentBet * ((ingenuity.parserModel as GameParserModel).getJackpotData()).minor;
        const miniJackpot = currentBet * ((ingenuity.parserModel as GameParserModel).getJackpotData()).mini;
        this.grandJackpotMeter.setCurrencyFormattedValue(grandJackpot.toString());
        this.majorJackpotMeter.setCurrencyFormattedValue(majorJackpot.toString());
        this.minorJackpotMeter.setCurrencyFormattedValue(minorJackpot.toString());
        this.miniJackpotMeter.setCurrencyFormattedValue(miniJackpot.toString());
    
      }

      /**
       * override to play reel glow animation
       */
      protected onShowFreeGame():void{
        super.onShowFreeGame();
        this.playReelGlow();
        dispatcher.fireEvent(eventDispatchers.UPDATE_JACKPOT_METERS_VALUES_FG);
      }

      /**
       * override to stop reel glow animation and clear sticky wild container
       */
      protected onHideFreeGame(): void {
        super.onHideFreeGame();
        this.stopReelGlow();
        dispatcher.fireEvent(eventDispatchers.HIDE_STICKY_WILD_CONTAINER)
      }
    
     

}
